import { useCallback, useReducer } from 'react';

export function useForceRender(): () => void {
  const [, forceRender] = useReducer((x: boolean) => !x, false);

  return useCallback(() => {
    forceRender();
  }, []);
}
